import './app/style.scss';

import './node_modules/@synisys/idm-ui-shell/app/lib/kendo/styles/kendo.common-material.min.css';
import './node_modules/@synisys/idm-ui-shell/app/lib/kendo/styles/kendo.material.min.css';
import './node_modules/@synisys/idm-ui-shell/app/lib/kendo/styles/kendo.rtl.min.css';

import * as Hammer from 'hammerjs';
window.Hammer = Hammer;
